(function($){

/** --------------------------------------------------
*   
*   pages - cart - CART GIFTS
*
*   INFO
*   this file contains all of the javascript that is
*   unique to the shopping cart gifts modal
*
*   TABLE OF CONTENTS
*   variables
*   document ready
*   drupal behavior
*   helper functions
*
*   -------------------------------------------------- */




/** --------------------------------------------------
    #variables
    -------------------------------------------------- */

	/* we save the scroll position when we open the modal: */
	var scrollPosition = 0;

	/* class that goes on the "html" element when the modal is open: */
	const FORM_SHOWN_CLASS = 'js-giftformshown';




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {
		if(isCartPage()) {

			/* close gift modal */
			/* **************** */

			/*
			 * when closing the gift modal:
			 * - remove the "FORM_SHOWN_CLASS" class
			 * - empty the #gift-form element (needed because of the way the modal gets opened - see "behavior" below)
			 * - reset the scroll-top position
			 */

			// -> click/touch background:
			$(document).on('click touchstart', '.gift-form-holder__background', function() {
				closeGiftModal();
			});

			// -> click close button:
			$(document).on('click keypress', '.gift-form-holder__close-button', function(event) {
				event.preventDefault();
				if (duo.Utils.a11yClick(event)) {
					closeGiftModal();
				}
			});

			// -> close via ESC-key:
			$(document).on('keydown.giftModal', function(event) {
				if(event.keyCode === 27) {
					if($('html').hasClass(FORM_SHOWN_CLASS)) {
						closeGiftModal();
					}
				}
			});

		}
	});




/** --------------------------------------------------
    #drupal behavior
    -------------------------------------------------- */

	Drupal.behaviors.shoppingCartGiftPage = {
		attach: function (context, settings) {
			if(isCartPage()) {

				/* open modal */
				/* ********** */

				/*
				 * the modal needs to open when clicking the "open-gift-form button" on the
				 * shopping cart page - but note:
				 * when clicking on the button, the module-code uses ajax to fill the contents
				 * of the gifts modal element (on form submit) - this means we can't use an onclick
				 * handler to show the modal, instead, we check to see if the container element has
				 * content
				 */

				const $giftFormBlock = $('#gift-form');
				if($.trim($giftFormBlock.html()).length) {
					if(!$('html').hasClass(FORM_SHOWN_CLASS)) {
						// -> get the scroll position:
						scrollPosition = $(window).scrollTop();
						// -> the page will have overflow hidden and the body will be set
						//    to position "fixed", to keep the scroll position, we set the
						//    top property:
						$('body').css('top', '-' + scrollPosition + 'px');
						// -> show the modal:
						$('html').addClass(FORM_SHOWN_CLASS);
					}
				}

			}
		}
	};




/** --------------------------------------------------
    #helper functions
    -------------------------------------------------- */

	function closeGiftModal() {
		$('html').removeClass(FORM_SHOWN_CLASS);
		$('#gift-form').empty();
		$(window).scrollTop(scrollPosition);
	} /* closeGiftModal */

	function isCartPage() {
		let isCartPage = false;

		if($('body').hasClass('path-cart')) {
			isCartPage = true;
		}

		return isCartPage;
	} /* isCartPage */




})(jQuery);
